import React, { useEffect, createElement } from 'react';
export function GoogleTag() {
  useEffect(() => {
    // Add gtag.js script
    const script1 = document.createElement('script');
    script1.async = true;
    script1.src = 'https://www.googletagmanager.com/gtag/js?id=AW-649210165';
    document.head.appendChild(script1);
    // Add gtag configuration script
    const script2 = document.createElement('script');
    script2.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'AW-649210165');
    `;
    document.head.appendChild(script2);
    // Cleanup function
    return () => {
      document.head.removeChild(script1);
      document.head.removeChild(script2);
    };
  }, []);
  return null;
}